import React from "react";
import { Wrapper, Block } from "./styled";

function Header({ score, time }) {
  const minutes = Math.floor(time / 60);
  const seconds = time - minutes * 60;

  return (
    <Wrapper>
      <Block type="score">{score}</Block>
      <Block type="time">
        {minutes}:{seconds < 10 ? 0 : ""}
        {seconds}
      </Block>
    </Wrapper>
  );
}

export default Header;
